import {FieldError} from "react-hook-form"

interface FormErrorBoxProps {
    error: FieldError | undefined
}

export const FormErrorBox = ({error}: FormErrorBoxProps) => {
    if (!error) return null
    return (
        <div className="help is-danger">
            {error?.message}
        </div>
    )
}